'use client'

import React, { useState, useEffect } from "react"
import { Swiper, SwiperSlide } from "swiper/react"

import 'swiper/css';
import 'swiper/css/pagination';

import { Pagination } from 'swiper/modules';
import Link from "next/link";
import Image from "next/image";
import Hashids from "hashids";
import { useGlobalContext } from "@/app/component/context/provider";

const MainBanner = ({ data }) => {
  // console.log(data);


  const { privateKey } = useGlobalContext()

  const banners = (data?.[0]?.column_book ?? []).flatMap((banner) => {
    if (!banner) return [];
    const positions = Array.isArray(banner.order_id)
      ? banner.order_id
      : String(banner.order_id ?? '').split(',').map((pair) => {
          const [order, com] = pair.split('_');
          return { order: Number(order), com: Number(com) };
        });
    const position = positions.find((item) => Number(item?.com) === 45);
    return position && Number.isFinite(Number(position.order))
      ? [{ banner, order: Number(position.order) }]
      : [];
  }).sort((a, b) => a.order - b.order);

  return (
    <div className="w-full bg-primary pt-4 pb-2">
      <div className="w-full max-w-[1920px] mx-auto">
        <Swiper
          breakpoints={{
            0: { slidesPerView: 1, spaceBetween: 16 },
            768: { slidesPerView: 2.25, spaceBetween: 16 },
            1024: { slidesPerView: 3, spaceBetween: 16 },
          }}
          pagination={{ clickable: true }}
          loop={true}
          centeredSlides={true}
          slidesPerView={1}
          modules={[Pagination]}
          className="mySwiper"
        >
          {banners.map(({ banner: data }, i) => {
            // ถ้า type = book,cartoon,audio,serie ใส่ id   ถ้า type = link ใส่ลิงค์  ถ้า type=none ไม่ต้องใส่อะไรและกดไม่ได้
            // ถ้ามีหน้ารวมหนังสือต้องมาเพิ่ม type = book
            // console.log(data);


            let url = '';
            switch (data.type) {
              case 'link':
                url = data.data_val;
                break;
              case 'serie':
                const hashids = new Hashids(privateKey, 6)
                const encodedID = hashids.encode(data.data_val)
                url = data.data_val ? `/ebook/${encodedID}` : '';
                break;
              case 'book':
                const link = `/ebook-set/${data.data_val}`
                url = link
                break;
              default:
                break;
            }

            return (
              <SwiperSlide key={i}>
                <div className="relative w-full aspect-[1200/720] max-h-[420px] overflow-hidden rounded-xl shadow-xs bg-gray-200 dark:bg-zinc-800">
                  <Link href={url} target="_blank" className="relative block w-full h-full">
                    {data.img && (
                      <Image
                        src={data.img}
                        alt="banner"
                        fill
                        unoptimized
                        priority={i < 3}
                        loading={i < 3 ? "eager" : "lazy"}
                        decoding={i < 3 ? "sync" : "async"}
                        sizes="(max-width: 768px) 100vw, (max-width: 1024px) 50vw, 33vw"
                        className="object-cover object-center"
                        onClick={url === '' ? (e) => e.preventDefault() : undefined}
                      />
                    )}
                  </Link>
                </div>
              </SwiperSlide>
            )
          })}
        </Swiper>
      </div>
    </div>

  );
}

export default MainBanner
